import { createSlice } from '@reduxjs/toolkit';

const bankTransactionExtractSlice = createSlice({
  name: 'bankTransactionExtract',
  initialState: {
    transactions: [],
    loading: false,
    error: null,
  },
  reducers: {
    extractLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    extractSuccess: (state, { payload }) => {
      state.transactions = payload;
      state.loading = false;
    },
    extractFailure: (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    },
  },
});

export const { extractLoading, extractSuccess, extractFailure } =
  bankTransactionExtractSlice.actions;

export default bankTransactionExtractSlice.reducer;
